<template>
  <section :class="[$style.menu, $style.container__menu]">
    <h2 :class="[$style.title, $style.menu__title]">LINE設定</h2>
    <ul :class="[$style.menu__list, $style.list]">
      <li v-for="link in links" :key="link.text" :class="$style.list__item">
        <RouterLink
          :to="link.to"
          :class="$style.link"
          :active-class="$style['link--active']"
        >
          {{ link.text }}
          <IconAngle />
        </RouterLink>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import IconAngle from '@/components/icons/IconAngle.vue'
import { type InternalLinkType } from '@/types/app'
import { computed } from 'vue'

type ConditionalLink = InternalLinkType & {
  condition: boolean
}

const links = computed(() => {
  const conditionalLinks: ConditionalLink[] = [
    {
      text: '友だち追加経路',
      to: {
        name: 'LineActivationSettingInflowSource',
      },
      condition: true,
    },
    {
      text: 'アカウント連携',
      to: {
        name: 'lineActivationSettingSelfGenerationId',
      },
      condition: true,
    },
    {
      text: 'カスタム項目',
      to: {
        name: 'LineActivationSettingUserVariableListView',
      },
      condition: true,
    },
  ]

  return conditionalLinks.filter(link => link.condition)
})
</script>

<style lang="scss" module>
.menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-4;

  &:nth-child(n + 2) {
    margin-top: 16px;
  }
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 16px;
}

.list {
  &__item {
    border-top: 1px solid $color-border-low-emphasis;
  }
}

.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 16px;
  color: $color-text-and-object-high-emphasis;

  &:hover {
    text-decoration: none;
    color: $color-text-and-object-accent-primary;
  }

  &--active {
    background-color: $color-surface-accent-primary-light;
    color: $color-text-and-object-accent-primary;
    font-weight: 700;
  }
}
</style>
